<div fxLayout="column" fxFlexAlign="center" class="container" [ngClass]="{ hide: !showDashboard }">
  <div fxLayout="row" fxLayoutAlign="center center">
    <div fxFlex="noshrink">
      <h1>Dashboard</h1>
    </div>
    <span fxFlex="grow"></span>
    <div fxFlex="noshrink" fxLayout="column"></div>
  </div>

  <div fxLayout="column" fxFlex="100%" fxLayoutGap="1%">
    <div fxLayout="row" fxLayoutGap="1%" fxLayout.lt-md="column" class="tile-row">
      <lift-by-spot-tile
        (showLiftFull)="showLiftFull($event)"
        class="tile"
        fxFlex.gt-sm="32.66%"
        [creatives]="creatives"
      ></lift-by-spot-tile>
      <traffic-by-affiliate-tile
        class="tile"
        fxFlex.gt-sm="32.66%"
        [creatives]="creatives"
      ></traffic-by-affiliate-tile>
      <traffic-by-source-tile
        class="tile"
        fxFlex.gt-sm="32.66%"
        [timezone]="timezone"
        [creatives]="creatives"
      ></traffic-by-source-tile>
    </div>
    <div fxLayout="row" class="tile-row mb-2">
      <micromoment-timeline-tile
        class="tile"
        fxFlex="100%"
        [creatives]="creatives"
      ></micromoment-timeline-tile>
    </div>
    <div fxLayout="row" class="tile-row">
      <time-of-day-tile
        class="tile"
        fxFlex="100%"
        [timezone]="timezone"
      ></time-of-day-tile>
    </div>
    <div fxLayout="row" class="tile-row">
      <kw-tile
        class="tile"
        fxFlex="100%"
        [timezone]="timezone"
        [creatives]="creatives"
      ></kw-tile>
    </div>
  </div>
</div>

<div *ngIf="!showDashboard">
  <lift-by-spot-full (goBack)="_showDashboard()" [averageLift]="averageLift" ></lift-by-spot-full>
</div>
